import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = {
  style: {"margin-left":"1%"},
  id: "msgdiv"
}
const _hoisted_3 = {
  id: "divMainList",
  class: "divMainList"
}
const _hoisted_4 = {
  key: 0,
  class: "serviceHeader"
}
const _hoisted_5 = {
  key: 1,
  class: "serviceHeader"
}
const _hoisted_6 = {
  key: 2,
  id: "tblMainList"
}
const _hoisted_7 = { class: "tdLstCategory" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  id: "divSpecification",
  class: "divSpecification"
}
const _hoisted_11 = { id: "tblDetailList" }
const _hoisted_12 = { class: "tdLstCategory" }
const _hoisted_13 = { id: "divHeaderDocumentDetail" }
const _hoisted_14 = { id: "tblHeaderDocumentDetailList" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Document Name")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Upload Date")
const _hoisted_17 = { id: "divDocumentDetail" }
const _hoisted_18 = { id: "tblDocumentDetailList" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" <Loading :isLoading=\"isLoading\" /> "),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createCommentVNode(" Category Detail By Service "),
    _createElementVNode("div", _hoisted_3, [
      ($setup.isBeforePageChange)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.strServiceHeader), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.strServiceCategoryHeader), 1 /* TEXT */)),
      ($setup.isBeforePageChange)
        ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstCategory[0], (item) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    key: item.order
                  }, [
                    (item.isShowing)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                          _createElementVNode("a", {
                            id: "hrefGoToDetail",
                            onClick: ($event: any) => ($setup.goToDetail(item))
                          }, _toDisplayString(item.description), 9 /* TEXT, PROPS */, _hoisted_9)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_10, _toDisplayString($setup.strServiceSpecification), 1 /* TEXT */)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createCommentVNode(" Detail Technical Document Information By Category "),
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("table", _hoisted_14, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, [
                          _hoisted_15,
                          _createElementVNode("a", {
                            style: {"float":"right"},
                            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.documentSort('documentName')))
                          }, _toDisplayString($setup.fileNameSortIcon), 1 /* TEXT */)
                        ]),
                        _createElementVNode("th", null, [
                          _hoisted_16,
                          _createElementVNode("a", {
                            style: {"float":"right"},
                            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.documentSort('updateDate')))
                          }, _toDisplayString($setup.updateDateSortIcon), 1 /* TEXT */)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("table", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstDocumentDetail[0], (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.updateDate
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              id: "hrefGoToDetail",
                              onClick: ($event: any) => ($setup.openDocumentFile(item))
                            }, _toDisplayString(item.documentName), 9 /* TEXT, PROPS */, _hoisted_19)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.updateDate), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  ($setup.isImgExist)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "imgDocument",
                        src: $setup.categoryImgPath,
                        alt: "Fetched Image"
                      }, null, 8 /* PROPS */, _hoisted_20))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ])
          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
      (!$setup.isBeforePageChange)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            class: "btnBackToCategory",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goBackCategoryList()))
          }, "Back"))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}